import { render, staticRenderFns } from "./MpinList.vue?vue&type=template&id=85d4f088&scoped=true&"
import script from "./MpinList.vue?vue&type=script&lang=js&"
export * from "./MpinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d4f088",
  null
  
)

export default component.exports